import React, { useState } from "react";
import Example from "./Example";
import RecentGraduateExample from "./RecentGraduateExample";
import YoungProfessionalExample from "./YoungProfessionalExample";
import ToggleSwitch from "../components/utility/ToggleComponent";
import "./ExampleOneComponent.css";

const examples = [
  { id: "recent-graduate", label: "Recent Graduate", available: true },
  { id: "young-professional", label: "Young Professional", available: true },
  { id: "mid-career", label: "Mid-Career Professional" },
  { id: "late-starter", label: "Late Starter" },
  { id: "near-retirement", label: "Near Retirement" },
  { id: "already-retired", label: "Already Retired" },
];

function ExampleOne() {
  const [selectedExample, setSelectedExample] = useState(examples[0].id);
  const [reducedLineHeight, setReducedLineHeight] = useState(true);
  const [careerExampleExpanded, setCareerExampleExpanded] = useState(true);
  const selected = examples.find((example) => example.id === selectedExample);

  return (
    <main className="examples-page">
      {careerExampleExpanded && <div className="examples-mobile-picker">
        <label htmlFor="example-picker">Choose an example</label>
        <select
          id="example-picker"
          value={selectedExample}
          onChange={(event) => setSelectedExample(event.target.value)}
        >
          {examples.map((example) => (
            <option key={example.id} value={example.id}>
              {example.label}{example.available ? "" : " — Coming soon"}
            </option>
          ))}
        </select>
      </div>}

      <div className={`examples-layout ${careerExampleExpanded ? "" : "career-card-collapsed"}`}>
        <aside className="examples-sidebar" aria-label="Retirement examples">
          <h2>Career stage</h2>
          <nav>
            {examples.map((example) => (
              <button
                type="button"
                key={example.id}
                className={selectedExample === example.id ? "active" : ""}
                onClick={() => setSelectedExample(example.id)}
                aria-current={selectedExample === example.id ? "page" : undefined}
              >
                <span>{example.label}</span>
                {!example.available && <small>Coming soon</small>}
              </button>
            ))}
          </nav>
        </aside>

        <section className="examples-content" aria-live="polite">
          {selected.available ? (
            selectedExample === "recent-graduate" ? (
              <RecentGraduateExample
                expanded={careerExampleExpanded}
                onToggle={() => setCareerExampleExpanded((current) => !current)}
              />
            ) : (
              <YoungProfessionalExample
                expanded={careerExampleExpanded}
                onToggle={() => setCareerExampleExpanded((current) => !current)}
              />
            )
          ) : (
            <div className="example-placeholder">
              <span className="placeholder-icon" aria-hidden="true">⌛</span>
              <h2>{selected.label}</h2>
              <p>This career-stage example is coming soon.</p>
              <button type="button" onClick={() => setSelectedExample("recent-graduate")}>
                View Recent Graduate
              </button>
            </div>
          )}
        </section>
      </div>

      <section className="legacy-examples">
        <Example id="ExampleOne" name="Example One" reducedLineHeight={reducedLineHeight} />
        <Example id="ExampleTwo" name="Example Two" reducedLineHeight={reducedLineHeight} />
        <Example id="ExampleThree" name="Example Three" reducedLineHeight={reducedLineHeight} />
        <Example id="ExampleFour" name="Example Four" reducedLineHeight={reducedLineHeight} />
        <Example id="ExampleFive" name="Example Five" reducedLineHeight={reducedLineHeight} />
        <Example id="ExampleSix" name="Example Six" reducedLineHeight={reducedLineHeight} />
        <div className="bottomRight">
          <ToggleSwitch
            title={reducedLineHeight ? "Reduced line height" : "Reduce line height"}
            value={reducedLineHeight}
            setter={setReducedLineHeight}
          />
        </div>
      </section>
    </main>
  );
}

export default ExampleOne;
